module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1674638308-2.1.11/node_modules/babel-runtime/regenerator/index.js
// module id = 69
// module chunks = 0